/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FC } from "react"
import { Button } from "@duxton-web/ui"
import { AddCircleFilled } from "@duxton-web/icons"
import { useTranslation } from "common/utils/i18n"
import useInventoryContext from "hooks/useInventoryContext"

interface IProps {
  disabledMode?: boolean
  onClick(): void
}

export const EmptyModifierGroups: FC<IProps> = ({
  disabledMode,
  onClick,
}: IProps) => {
  const { hideCreateAction } = useInventoryContext()

  const textCreate = useTranslation("menu.modifierGroup.createButton")
  return (
    <div
      css={css`
        height: 100%;
      `}
    >
      <div
        css={css`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          display: flex;
          flex-flow: column;
          align-items: center;
        `}
      >
        <img
          data-test="empty-img"
          src={require("./emptyItems.svg")}
          height={160}
          width={160}
        />
        {!hideCreateAction && (
          <Button
            data-test="create-btn"
            icon={<AddCircleFilled />}
            onClick={onClick}
            disabled={disabledMode}
          >
            {textCreate}
          </Button>
        )}
      </div>
    </div>
  )
}
